<template>
  <transition name="header" appear>
    <div class="head_bar flex" v-show="headerShow">
      <div class="flex">
        <router-link to="/">
          <img src="@/assets/images/logo_alt.png" class="header_logo" />
        </router-link>
        <div class="header_title" title="教师资源平台"></div>
        <div class="header_menu flex">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="首页" name="index"></el-tab-pane>
            <el-tab-pane
              label="教师工作台"
              name="workspace"
              v-if="showWorkspace"
            ></el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div class="flex">
        <HeadCourseTeaching v-if="isIndex" />
        <div
          class="message"
          @click="jumpToMyItem(`message`)"
          v-if="loginStatus && !ifReviewAccount"
        >
          <el-badge is-dot :hidden="!isRead">
            <el-image
              class="message-icon"
              :src="require(`@/assets/icons/icon_message_header.png`)"
              fit="cover"
            >
            </el-image>
          </el-badge>
        </div>
        <div class="flex">
          <img class="user_avatar" :src="getAvatar" alt="" />
          <el-popover
            v-if="loginStatus"
            trigger="hover"
            popper-class="head_popoer"
          >
            <div class="popover_body">
              <div class="popover_body_content">
                <div class="popover_body_block">
                  <div class="popover_body_title">
                    <img
                      src="@/assets/icons/icon_user_head.png"
                      class="icon_head_popover"
                    />
                    <div class="cell_content" style="font-weight: bold">
                      {{ userName }}
                    </div>
                    <template v-if="!ifReviewAccount">
                      <div
                        class="personal_center"
                        @click="jumpToMyItem(`personal`)"
                      >
                        个人资料 <i class="el-icon-arrow-right" />
                      </div>
                    </template>
                  </div>
                  <div class="popover_body_detail">
                    <template v-if="!ifReviewAccount">
                      <div class="cell">
                        <div
                          class="my_collection"
                          @click="jumpToMyItem(`favorite`)"
                        >
                          <img
                            src="@/assets/icons/icon_collection_head.png"
                            class="icon_head_popover"
                          />
                          我的收藏
                        </div>
                        <div
                          class="my_afterclass"
                          @click="jumpToMyItem(`afterclass`)"
                        >
                          <img
                            src="@/assets/icons/icon_myAfterclass_head.png"
                            class="icon_head_popover"
                          />
                          我的班级
                        </div>
                      </div>
                      <div
                        class="cell my_document"
                        @click="jumpToMyItem('document')"
                      >
                        <div class="cell_icon">
                          <img src="@/assets/icons/icon_file_head.png" />
                        </div>
                        <div class="cell_content">我的文件</div>
                        <div class="cell_action">
                          <i class="el-icon-arrow-right" />
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
                <div class="popover_body_block">
                  <div class="popover_body_title">
                    <div class="border_title"></div>
                    账号管理
                  </div>
                  <div class="popover_body_detail">
                    <div class="cell">
                      <div class="cell_icon">
                        <img src="@/assets/icons/icon_pw_head.png" />
                      </div>
                      <div class="cell_content">登录密码</div>
                      <div class="cell_action">
                        <a @click="openPasswordReset()"
                          >重置 <i class="el-icon-arrow-right"
                        /></a>
                      </div>
                    </div>
                    <div class="cell">
                      <div class="cell_icon">
                        <img src="@/assets/icons/icon_wx_head.png" />
                      </div>
                      <div class="cell_content">
                        {{ wxBindStatus ? "已绑定" : "暂未绑定" }}
                      </div>
                      <div class="cell_action">
                        <a
                          class="unbind"
                          @click="dialogHandle = true"
                          v-if="wxBindStatus"
                          >解绑 <i class="el-icon-arrow-right"
                        /></a>
                        <a @click="bindWx()" v-else
                          >立即绑定 <i class="el-icon-arrow-right"
                        /></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="popover_body_button" @click="logout()">退出登录</div>
            </div>
            <div slot="reference" class="user_name">
              {{ userName }}<i class="el-icon-arrow-down el-icon--right" />
            </div>
          </el-popover>
          <el-dropdown class="flex user_info" @command="menuCommand" v-else>
            <span class="user_name"
              >游客<i class="el-icon-arrow-down el-icon--right"
            /></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="login">登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <!-- 解绑微信弹窗 -->
      <el-dialog
        :visible.sync="dialogHandle"
        :modal-append-to-body="false"
        @closed="verifyCode = ''"
        width="36.8rem"
        custom-class="unbind_dialog"
      >
        <div class="unbind_title">身份验证</div>
        <div class="unbind_tips">
          为了保护您的账号安全，请验证身份后进行下一步操作
        </div>
        <div class="unbind_phone">使用手机{{ showPhoneNum }} 验证</div>
        <div class="unbind_input">
          <input
            type="tel"
            placeholder="请输入六位短信验证码"
            v-model="verifyCode"
            class="unbind_code"
            maxlength="6"
          />
          <div class="unbind_code_count" v-if="getCodeHandle">
            {{ countWords }}
          </div>
          <div class="unbind_code_button" v-else @click="sendCode()">
            发送验证码
          </div>
        </div>
        <div
          class="unbind_button"
          @click="unbind()"
          :class="{ disable: !verifyCode }"
        >
          确认
        </div>
      </el-dialog>
      <!-- 重置密码弹窗 -->
      <el-dialog
        custom-class="password_reset"
        :visible.sync="passwordResetHandle"
        :modal-append-to-body="false"
        @close="passwordResetClose()"
        width="43.2rem"
      >
        <PasswordReset ref="passwordReset" @success="passwordResetClose" />
      </el-dialog>
      <!-- 新用户设置密码弹窗 -->
      <el-dialog
        custom-class="password_reset"
        :visible.sync="passwordSetHandle"
        :modal-append-to-body="false"
        @close="passwordSetClose()"
        width="39.3rem"
      >
        <PassWordSet ref="passwordSet" @success="passwordSetClose" />
      </el-dialog>
    </div>
  </transition>
</template>

<script>
import { Component, Vue, Watch } from "vue-property-decorator";
import { getCode, getLoginUrl } from "@/api/login";
import { unbindWX, getUserInfo, getIsRead } from "@/api/user";
import PassWordSet from "@/components/head/passwordSet";
import PasswordReset from "@/components/head/passwordReset";
import HeadCourseTeaching from "@/components/head/headCourseTeaching.vue";
import { homepage } from "@/config/env";
import userAvatar from "@/assets/icons/icon_user.png";
@Component({
  components: {
    PasswordReset,
    PassWordSet,
    HeadCourseTeaching,
  },
})
export default class HeadBar extends Vue {
  //控制顶部导航是否出现
  headerShow = true;
  //滚轮
  roller = null;

  userAvatar = userAvatar;

  verifyCode = "";
  dialogHandle = false;
  passwordResetHandle = false;
  passwordSetHandle = false;
  getCodeHandle = false;
  countdown = null;
  interval = null;
  activeName = null;
  isRead = null;

  @Watch("roller")
  valueChange(newValue, oldValue) {
    //只有首页会有该功能
    if (this.$route.path == "/course" || this.$route.path == "/course/") {
      this.headerShow = newValue > oldValue ? false : true;
      //针对点击分类往上走的时候，顶部栏会下来的情况
      if (
        oldValue > newValue &&
        this.$store.state.CourseModule.headerShow == false
      ) {
        this.headerShow = false;
      }
      if (newValue < 200) {
        this.headerShow = true;
      }
    } else {
      this.headerShow = true;
    }
  }

  @Watch("routePath")
  routeChange(newValue, oldValue) {
    this.activeName = newValue.match("/workspace") ? "workspace" : "index";
  }

  get isIndex() {
    const route = this.$route.name;
    return route == "courseIndex";
  }

  get userName() {
    if (this.$store.state.UserModule.userInfo)
      return this.$store.state.UserModule.userInfo.name;
    else return "";
  }

  get showWorkspace() {
    const ifBanedUser = this.$store.state.UserModule.userInfo?.hasReviewAccount;
    return !ifBanedUser && this.loginStatus;
  }

  get loginStatus() {
    return this.$store.state.AuthModule.loginStatus;
  }

  get wxBindStatus() {
    if (this.$store.state.UserModule.userInfo)
      return this.$store.state.UserModule.userInfo.userOauthMap
        ? this.$store.state.UserModule.userInfo.userOauthMap.wx
        : false;
    else return false;
  }

  get showPhoneNum() {
    if (this.$store.state.UserModule.userInfo) {
      const showPhoneNum = this.$store.state.UserModule.userInfo.phone || "";
      return showPhoneNum.replace(/^(\d{3})\d+(\d{4})$/, "$1****$2");
    } else {
      return "";
    }
  }
  get countWords() {
    return `剩余${this.countdown}秒`;
  }

  get routePath() {
    return this.$route.fullPath;
  }

  get ifReviewAccount() {
    return this.$store.state.UserModule.userInfo?.hasReviewAccount;
  }

  get getAvatar() {
    return this.$store.state.UserModule.userInfo?.avatar || this.userAvatar;
  }

  mounted() {
    //判断当前位置
    this.activeName = this.routePath.match("/workspace")
      ? "workspace"
      : "index";
    //添加对滚轮的监听
    window.addEventListener("scroll", this.setScroll);

    if (this.loginStatus) {
      const hasPassword = this.$store.state.UserModule.userInfo.hasPassword;
      const setPassword = localStorage.getItem("setPassword");
      if (!hasPassword && !setPassword) {
        this.passwordSetHandle = true;
      }
      this.getIsRead();
    }
  }

  getIsRead() {
    getIsRead().then((res) => {
      this.isRead = res;
    });
  }

  beforeDestroy() {
    window.removeEventListener("scroll", this.setScroll);
  }

  setScroll() {
    this.roller =
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      window.pageYOffset;
  }

  handleClick(tab, event) {
    if (tab.label === "首页") {
      //判断是否本来就是首页，是的话刷新，不是就跳转
      if (this.$route.path != "/course" && this.$route.path != "/course/") {
        this.$router.push("/course");
      } else {
        return;
      }
    } else {
      //判断是否本来就是教师工作台，是的话刷新，不是就跳转
      if (this.$route.path != "/workspace") {
        this.$router.push("/workspace");
      } else {
        return;
      }
    }
  }

  menuCommand(ev) {
    if (ev == "logout") {
      this.logout();
    } else if (ev == "login") {
      this.login();
    }
  }
  bindWx() {
    const redirectUrl = window.location.origin + homepage;
    getLoginUrl(redirectUrl).then((data) => {
      window.location.href = data;
    });
  }
  unbind() {
    if (this.verifyCode) {
      const param = {
        code: this.verifyCode,
        oauthAppTypeEnum: "wx",
      };
      const that = this;
      unbindWX(param)
        .then((data) => {
          if (data) {
            that.dialogHandle = false;
            this.$message({
              message: "解绑成功！",
              type: "success",
              offset: 120,
              customClass: "errorTips",
            });
            getUserInfo()
              .then((info) => {
                this.$store.commit("UserModule/setUserInfo", info);
              })
              .catch((err) => console.log(err));
          }
        })
        .catch((err) => {
          // this.$message.error(err)
        });
    }
  }
  sendCode() {
    const param = {
      templateCodeTypeEnum: "COMMON_SMS",
      mobile: this.$store.state.UserModule.userInfo.phone,
    };
    getCode(param).then(() => {
      this.$message({
        message: "发送成功！",
        type: "success",
        offset: 120,
        customClass: "errorTips",
      });
      this.countdown = 60;
      this.getCodeHandle = true;
      this.interval = setInterval(() => {
        this.countdown--;
        if (this.countdown < 0) {
          clearInterval(this.interval);
          this.getCodeHandle = false;
        }
      }, 1000);
    });
  }
  logout() {
    this.$store.dispatch("AuthModule/logout");
    this.$router.replace("/login");
  }
  login() {
    this.$router.push("/login");
  }
  openPasswordReset() {
    this.passwordResetHandle = true;
  }
  passwordSetClose() {
    this.$refs.passwordSet.resetForm();
    this.passwordSetHandle = false;
    localStorage.setItem("setPassword", true);
    getUserInfo()
      .then((info) => {
        this.$store.commit("UserModule/setUserInfo", info);
      })
      .catch((err) => console.log(err));
  }
  passwordResetClose() {
    this.$refs.passwordReset.resetForm();
    this.passwordResetHandle = false;
    getUserInfo()
      .then((info) => {
        this.$store.commit("UserModule/setUserInfo", info);
      })
      .catch((err) => console.log(err));
  }
  jumpToMyItem(type) {
    if (type === "favorite") {
      if (this.$route.path !== "/mine/myCollection")
        this.$router.push(`/mine/myCollection`);
    } else if (type === "personal") {
      if (
        this.$route.path !== "/personal/personalInfo" &&
        this.$route.path !== "/personal"
      )
        this.$router.push(`/personal/personalInfo`);
    } else if (type === "message") {
      if (this.$route.path !== "/personal/messageCenter") {
        this.$router.push(`/personal/messageCenter`);
      } else {
        location.reload();
      }
    } else if (type === "document") {
      if (this.$route.path !== "/mine/myDocument")
        this.$router.push(`/mine/myDocument`);
    } else {
      if (this.$route.path !== "/mine/myAfterclass")
        this.$router.push(`/mine/myAfterclass`);
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.unbind_dialog .el-dialog__header {
  display: none;
}
/deep/.unbind_dialog .el-dialog__body {
  padding: 3.7rem 3.3rem;
}
/deep/.password_reset .el-dialog__body {
  padding: 0;
}

.unbind_dialog {
  .unbind_title,
  .unbind_phone {
    text-align: center;
    font-weight: bold;
    font-size: 1.8rem;
  }
  .unbind_tips {
    margin: 2.3rem 6.3rem;
    text-align: center;
    font-size: 1.4rem;
    color: #999999;
  }
  .unbind_input {
    margin-top: 2rem;
    display: flex;
    align-items: center;
    border-bottom: solid 1px #d1d1d1;
    .unbind_code {
      box-sizing: border-box;
      width: 20rem;
      font-size: 1.6rem;
      padding: 1rem 0;
      border: none;
      outline: none;
      &::placeholder {
        color: #999999;
      }
    }
    .unbind_code_button,
    .unbind_code_count {
      font-size: 1.4rem;
      color: #00a2e9;
      flex: 1;
      text-align: center;
    }
    .unbind_code_button {
      cursor: pointer;
    }
  }
  .unbind_button {
    background: #00a2e9;
    color: #ffffff;
    font-size: 1.4rem;
    padding: 1rem;
    border-radius: 0.4rem;
    text-align: center;
    margin-top: 7rem;
    cursor: pointer;
  }
  .disable {
    opacity: 0.4;
  }
}

.el-dropdown-menu__item {
  font-size: 1.4rem;
}
.flex {
  align-items: center;
  display: flex;
}
.user_avatar {
  border-radius: 50rem;
  width: 3rem;
  height: 3rem;
}
.head_bar {
  font-size: 1.4rem;
  box-sizing: border-box;
  padding: 0 8rem;
  background: #ffffff;
  color: #ffffff;
  height: 8rem;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 4090;
  box-shadow: 0px 1px 0px 0px #f1f2f4;
  /deep/ .el-dropdown {
    font-size: 1.4rem;
  }
}

//头部动画
.header-enter-active {
  animation: header 0.2s;
}

.header-leave-active {
  animation: header 0.2s reverse;
}

@keyframes header {
  from {
    transform: translateY(-8rem);
  }
  to {
    transform: translateY(0);
  }
}

.header_logo {
  width: auto;
  height: 3rem;
  margin-right: 6rem;
}
.header_title {
  font-family: "MiSans-Heavy";
  font-size: 1.6rem;
  font-weight: bold;
  margin-left: 1rem;
  margin-right: 4.5rem;
}
.header_menu {
  margin-top: 1rem;
  user-select: none;
}

.message {
  margin-right: 3rem;
  cursor: pointer;
  position: relative;
  top: 0.5rem;

  .message-icon {
    height: 2.4rem;
    width: 2.6rem;
  }
}

.user_info {
  cursor: pointer;
}
.user_name {
  cursor: pointer;
  color: #333333;
  height: 8rem;
  line-height: 8rem;
  padding: 0 0.5rem;
}
.popover_body {
  width: 34.4rem;
  .popover_body_content {
    padding: 2.3rem;
    .popover_body_title {
      position: relative;
      display: flex;
      align-items: center;
      font-size: 1.6rem;
      color: #666666;
      .icon_head_popover {
        width: 2rem;
        height: 2rem;
        margin-right: 0.5rem;
      }
    }
    .border_title {
      width: 4px;
      height: 1.6rem;
      background: #666666;
      border-radius: 2px;
      position: relative;
      top: 0.05rem;
      margin-right: 10px;
    }
  }
  .popover_body_button {
    width: calc(100% - 46px);
    margin: 0 auto;
    padding: 2.4rem 0 2rem;
    cursor: pointer;
    text-align: center;
    font-size: 1.6rem;
    color: #666666;
    border-top: solid 1px #ebeded;
  }
}
.cell {
  &:last-child {
    padding: 2.5rem 0;
  }

  padding: 2.5rem 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .cell_icon {
    height: 2rem;
    width: 2rem;
    margin: 0 1rem;
    position: relative;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .cell_action {
    margin-left: 2.5rem;
    a {
      &:hover {
        color: #00a2e9;
      }
      color: #666666;
      font-size: 1.6rem;
      cursor: pointer;
      text-decoration: none;
    }
    .unbind {
      color: #666666;
    }
  }

  .my_collection,
  .my_afterclass {
    width: 14rem;
    height: 7.5rem;
    color: #000000;
    font-size: 1.6rem;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    img {
      width: 1.8rem;
      height: 1.8rem;
      margin-right: 0.6rem;
    }
  }

  .my_collection {
    background: linear-gradient(0deg, #fff6f6 0%, #ffe8e8 100%);
    border-radius: 10px;
  }

  .my_afterclass {
    background: linear-gradient(0deg, #f1fbff 0%, #caecfb 100%);
    border-radius: 10px;
  }
}

.my_document {
  padding: 1rem 0 !important;
  margin: 1.5rem 0;
  cursor: pointer;
  border-radius: 1rem;
}

.cell_content {
  flex: 1;
  font-size: 1.8rem;
  font-weight: 600;
  color: #000000;
  word-break: keep-all;
  overflow: hidden;
  text-overflow: ellipsis;
}

.personal_center {
  color: #666666;
  font-size: 1.6rem;
  cursor: pointer;
  &:hover {
    color: #00a2e9;
  }
}
</style>